import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentService } from 'src/app/pages/payment/services/payment/payment.service';
import { UserInfoService } from 'src/app/shared/services/UserInfoService/user-info.service';

declare let fbq: Function;
declare let ttq: any;

@Component({
  selector: 'app-course-details',
  templateUrl: './course-details.component.html',
  styleUrls: ['./course-details.component.css'],
})
export class CourseDetailsComponent implements OnInit {
  @Input() data!: any;
  @Input() language!: string;

  isProductPurchased: boolean | null = null;
  userInfo: any;
  showAll = false;

  private readonly productNames: { [key: string]: string } = {
    'grammar': 'كورس النحو',
    'dictation': 'كورس الاملاء',
    'grammar-dictation': 'كورس النحو والاملاء',
  };

  constructor(
    private paymentService: PaymentService,
    private route: ActivatedRoute,
    private router: Router,
    private userInfoService: UserInfoService,
  ) {
    this.userInfo = this.userInfoService.getUserInfo();
  }

ngOnInit() {

  this.checkProductPurchased();
  this.trackViewContent();
}

  private getProductName(productKey: string): string {
    return this.productNames[productKey] ?? productKey;
  }

private trackViewContent(): void {
  const productKey = this.route.snapshot.params['filename'];
  const productName = this.getProductName(productKey);

  setTimeout(() => {
    if (typeof fbq !== 'undefined') {
      fbq('track', 'ViewContent', {
        content_ids: [productKey],
        content_name: productName,
        content_type: 'product',
      });
  
    } 

    if (typeof ttq !== 'undefined') {
      ttq.track('ViewContent', {
        content_id: productKey,
        content_name: productName,
        content_type: 'product',
      });
    
    } 
  }, 1000);
}

  checkProductPurchased() {
    const productKey = this.route.snapshot.params['filename'];
    this.paymentService
      .checkIsProductPurchased(productKey)
      .then((isPurchased) => {
        this.isProductPurchased = isPurchased ? true : false;
      })
      .catch(() => {
        this.isProductPurchased = false;
      });
  }

  onSubscribeClick() {
    const productKey = this.route.snapshot.params['filename'];

    if (!this.userInfo?.accessToken) {
      this.router.navigate([`/ar/payment`], {
        state: { productKey: productKey, isNewUser: true },
      });
    } else {
      this.router.navigate([`/ar/payment`], {
        state: { productKey: productKey, isNewUser: false },
      });
    }
  }
}